import React from "react";
import Header from "../../components/Header";

const ShippingDelivery = () => {
  return (
    <>
    <Header/>
    
    <main>
      {/* breadcrumb start */}
      <section id="h1-breadcrumb">
        <div className="  relative pt-[150px] md:pt-[70px]">
         <h1
  data-aos="fade-up"
  className="text-3xl md:text-6xl font-black text-[#3F3D3A]  text-center"
>
  Shipping
  <span className="bg-gradient-to-r from-[#D4CB2F] via-[#E6DD57] to-[#55534F] bg-clip-text text-transparent">
    {" "} & Delivery
  </span>
</h1>
        </div>
      </section>
      {/* breadcrumb end */}

      {/* blog start  */}
      <section className="w-full py-16 md:py-[80px]" data-aos="fade">
        <div className="theme-container mx-auto w-full text-[14px] md:text-base">
          <i className="text-[14px] mb-2 inline-block font-semibold">
            Last updated on July 10th 2026
          </i>
          <ul>
            <li className="mb-2">
              1. Service orders are fulfilled by our empaneled health providers
              through their qualified technicians or phlebotomist or staff.
            </li>
            <li className="mb-2">
              2. Product orders are shipped through registered domestic courier
              companies and /or speed post only.
            </li>
            <li className="mb-2">
              3. Orders are shipped within 0-7 days or as per the delivery date
              agreed at the time of order confirmation and delivering of the
              shipment subject to availability of product / subject to Courier
              Company / post office norms.
            </li>
            <li className="mb-2">
              4. S Meera Health is not liable for any delay in delivery by the
              courier company / postal authorities and only guarantees to hand
              over the consignment to the courier company or postal authorities
              within 0-7 days rom the date of the order and payment or as per
              the delivery date agreed at the time of order confirmation.
            </li>
            <li className="mb-2">
              5. Delivery of all orders will be to the address provided by the
              buyer.
            </li>
            <li className="mb-2">
              6. Delivery of our services will be confirmed on your mail ID as
              specified during registration. For any issues in utilising our
              services you may contact our help desk on
              <a className="pr-[4px] text-theme font-semibold cursor-pointer" href="tel:919711300776" style={{ display: "inline-block" }}>
               0261 360 0552
              </a>
              or
              <a className="px-[4px] text-theme font-semibold cursor-pointer" href="mailto:support@smeerahealth.com" style={{ display: "inline-block" }}>
                support@smeerahealth.com
              </a>
              .
            </li>
          </ul>
        </div>
      </section>
      {/* blog end  */}
    </main>
    </>
  );
};

export default ShippingDelivery;
